import React from 'react';

import styled from 'styled-components';

import { parseNotificationMessageType } from '../../../utils/normalizers/notificationMessageType';
import { parseIconType } from '../../../utils/normalizers/parseIconByNotificationType';

interface IAlertIndicatorIcon {
  type: string;
}

export const AlertIndicatorIcon = ({ type }: IAlertIndicatorIcon) => {
  return <Div type={parseNotificationMessageType(type)}>{parseIconType(type)}</Div>;
};

const Div = styled.div<IAlertIndicatorIcon>`
  position: relative;
  width: 100%;

  &:hover::after {
    content: '${({ type }) => type}';
    position: absolute;
    bottom: -14px;
    left: 45%;
    transform: translateX(-45%);
    transition: 200ms ease-in-out;
    background-color: #fff;
    box-shadow: 0 0 10px 0px rgba(0, 0, 0, 0.1);
    font-size: 10px;
    padding: 3px 5px;
    border-radius: 6px;
  }
`;
